import { Select, Textarea } from "@mantine/core";
import { HttpError, IResourceComponentsProps } from "@refinedev/core";
import { Edit, useForm } from "@refinedev/mantine";
import DateTimePicker from "components/common/DateTimePicker";
import { UpdateTeaAddonSubscription } from "entities/tea_addon_subscription";
import { selectStatuses } from "entities/tea_addon_subscription/status";

export const TeaAddonSubscriptionEdit: React.FC<
  IResourceComponentsProps
> = () => {
  const {
    getInputProps,
    saveButtonProps,
    values,
    setFieldValue,
    refineCore: { queryResult },
  } = useForm<
    UpdateTeaAddonSubscription,
    HttpError,
    UpdateTeaAddonSubscription
  >({
    initialValues: {
      started_at: new Date(),
      last_payment_at: new Date(),
      next_renewal_at: new Date(),
      canceled_at: new Date(),
      status: "active",
      notes: "",
    },
  });

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      canDelete={false}
      title="Update tea addon subscription"
    >
      <Select
        placeholder="Status"
        data={selectStatuses}
        label="Status"
        {...getInputProps("status")}
      />
      <DateTimePicker
        type="date"
        label="Started At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        {...getInputProps("started_at")}
      />
      <DateTimePicker
        type="date"
        label="Next Renewal At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        {...getInputProps("next_renewal_at")}
      />
      <DateTimePicker
        type="date"
        label="Last Payment At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        clearable
        {...getInputProps("last_payment_at")}
      />
      <DateTimePicker
        type="date"
        label="Canceled At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        clearable
        {...getInputProps("canceled_at")}
      />
      <Textarea
        defaultValue=""
        mt="sm"
        label="Notes"
        {...getInputProps("notes")}
      />
    </Edit>
  );
};
